export default __webpack_public_path__ + "static/media/bolero3.a1fa80da.jpg";